<template>
  <div class="timer transfer__wrapper">
    <Modal :title="$t('superPass.timer.title')" :sub-title="$t('superPass.timer.subTitle')" @close="$router.push('/')">
      <template #text>
        <div class="transfer__form">
          <div class="timer__subtitle">{{ $t('superPass.timer.subTitle') }}</div>
          <div class="divider" />

          <div class="step">
            <div class="step__content">
              <div class="step__header">
                <div class="step__number">1</div>
                <div class="step__title">{{ $t('superPass.timer.step.first.title') }}</div>
              </div>
              <div class="step__progress">
                <ProgressBar :percentage="percentage" :description="statusMessages[0]" />
                <span class="description">{{ statusMessages[1] }}</span>
              </div>
            </div>
          </div>

          <div class="divider" />

          <div class="step" :class="{ disabled: isSecondStepDisabled }">
            <div class="step__content">
              <div class="step__header">
                <div class="step__number">2</div>
                <div class="step__title">{{ $t('superPass.timer.step.second.title') }}</div>
              </div>
              <div class="step__description">
                <span>{{ $t('superPass.timer.step.second.user') }}</span>
                <div class="step__user-name">
                  <span>
                    {{ supplierUsername }}
                  </span>
                </div>
              </div>
              <div class="step__info-text">
                {{ $t('superPass.timer.step.second.action') }}
                <br />
                <strong>Join (Присоединиться)</strong>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <Button
          class="step__button"
          :disabled="isSecondStepDisabled"
          icon-type="solid"
          right-icon="/transfer/arrow-right.svg"
          @click="redirectToRoblox"
        >
          {{ $t('superPass.timer.step.second.redirectToAccount') }}
        </Button>
        <div class="transfer__form-footer">
          <div v-if="!isSecondStepDisabled" class="message" :class="{ error: remainingTimeInGame <= 60 }">
            <div class="message__icon">!</div>
            <div class="message__description">{{ $t('superPass.timer.warningText') }}</div>
            <div class="message__time">
              <span class="text">{{ $t('superPass.timer.left') }}</span>
              <span class="number">
                {{ convertSecondsToTime(remainingTimeInGame) }}
              </span>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import ProgressBar from '@/components/ProgressBar/ProgressBar.vue'

import Button from '@/components/Base/Button/Button.vue'

import audio from '@/mixins/audio'
import Modal from '@/components/Base/Modal/modal.vue'
import { convertSecondsToTime, formatMinutesToHours } from '@/utils/time'

const ONE_ORDER_BEFORE_TIME = 180

export default {
  name: 'SuperPassTimer',
  components: {
    Modal,
    ProgressBar,
    Button
  },
  inject: ['currencyMap'],
  mixins: [audio],
  props: {
    order: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      elapsedTime: 0,
      interval: null,
      elapsedTimeInGame: 0,
      intervalInGame: null
    }
  },
  watch: {
    isSecondStepDisabled: {
      handler(value) {
        if (!value) {
          this.playBellSound()
        }
      },
      immediate: true
    }
  },
  computed: {
    isSecondStepDisabled() {
      return this.order?.status !== 'in_game'
    },
    startTime() {
      return new Date(this.order.date)?.getTime()
    },
    percentage() {
      if (!this.isSecondStepDisabled) return 100
      // return +Math.min((this.elapsedTime / (15 * 60)) * 100, 100).toFixed(0)

      if (this.orderFirstInLine) {
        return +Math.min((this.elapsedTime / ONE_ORDER_BEFORE_TIME) * 100, 100).toFixed(0)
      }
      const { all_count_orders_before: allCountOrdersBefore, before_orders: beforeOrders } = this.order
      if (!beforeOrders) return 90
      if (allCountOrdersBefore === 1) return 50

      return Math.floor(((allCountOrdersBefore - beforeOrders) / allCountOrdersBefore) * 100)
    },
    // remainingTime() {
    //   return Math.max(15 * 60 - this.elapsedTime, 0)
    // },
    statusMessages() {
      if (!this.isSecondStepDisabled) {
        return [this.$t('superPass.timer.statuses.ready'), this.$t('superPass.timer.statuses.waiting')]
      }

      // const timeLeft = this.remainingTime
      const timeLeftMinutes = Math.floor(this.timeLeft / 60)

      if (this.timeLeft > 800) {
        return [
          this.$t('superPass.timer.left') + ` ~${formatMinutesToHours(timeLeftMinutes)}`,
          this.$t('superPass.timer.statuses.timeIncreased')
        ]
      }
      if (this.timeLeft > 600) {
        return [this.$t('superPass.timer.left') + ' ~10 минут', this.$t('superPass.timer.statuses.startingOrder')]
      }
      if (this.timeLeft > 180) {
        return [this.$t('superPass.timer.left') + ' ~5 минут', this.$t('superPass.timer.statuses.launchingGame')]
      }
      if (this.timeLeft <= 180 && this.isSecondStepDisabled) {
        return [this.$t('superPass.timer.left') + ' ~3 минуты', this.$t('superPass.timer.statuses.preparingPass')]
      }

      return [this.$t('superPass.timer.statuses.ready'), this.$t('superPass.timer.statuses.waiting')]
    },
    startTimeInGame() {
      return new Date(this.order.in_game_date)?.getTime()
    },
    remainingTimeInGame() {
      return Math.max(5 * 60 - this.elapsedTimeInGame, 0)
    },
    supplierUsername() {
      return this.isSecondStepDisabled ? 'Пожалуйста, подождите' : this.order.supplier_roblox_username
    },
    timeLeft() {
      return (this.order?.before_orders || 1) * ONE_ORDER_BEFORE_TIME
    },
    orderFirstInLine() {
      return !this.order?.before_orders && !this.order?.all_count_orders_before
    }
  },
  methods: {
    convertSecondsToTime,

    redirectToRoblox() {
      window.open(this.order?.supplier_roblox_url, '_blank')
    },
    updateTimer() {
      // this.elapsedTime = Math.floor((Date.now() - this.startTime) / 1000)
      if (this.orderFirstInLine) this.elapsedTime = Math.floor((Date.now() - this.startTime) / 1000)
      this.elapsedTimeInGame = Math.floor((Date.now() - this.startTimeInGame) / 1000)
    }
  },
  mounted() {
    this.interval = setInterval(this.updateTimer, 10)
    this.intervalInGame = setInterval(this.updateTimer, 10)
  },
  beforeDestroy() {
    clearInterval(this.interval)
    clearInterval(this.intervalInGame)
  }
}
</script>

<style lang="scss">
@import './superPassTimer';
</style>
